<section class="not-found">
  <!-- not found content -->
  <section class="not-found__content">
    <!-- not found return text -->
    <p class="return-text">
      {{ '404Page.returnMessage' | translate }} {{ counter }}
      {{ '404Page.seconds' | translate }}
    </p>
    <!-- not found title & description -->
    <div class="titles-container">
      <!-- title -->
      <h1 class="titles-container__title">
        {{ '404Page.404Error' | translate }}
      </h1>
      <!-- description -->
      <p class="titles-container__subtitle">
        {{ '404Page.errorDescription' | translate }}
      </p>
    </div>

    <!-- not found back btn -->
    <a routerLink="/" class="not-found__cta">
      <pwj-button
        variant="primary"
        size="large"
        icon="chevron-right"
        [rotateIconInRtl]="true"
        [iconReversePosition]="true"
        [wFull]="true"
        >{{ '404Page.returnToSite' | translate }}</pwj-button
      >
    </a>
  </section>
  <!-- not found image -->
  <img
    class="not-found__image"
    ngSrc="assets/images/404.svg"
    width="548"
    height="504"
    alt="" />
</section>
